import { ReactNode } from "react";

interface VoiceContainerProps {
  children: ReactNode;
  className?: string;
}

interface SlotProps {
  children: ReactNode;
}

/**
 * Voice container component with slot pattern
 * Mirrors ChatContainer structure for consistency
 */
export function VoiceContainer({
  children,
  className = "",
}: VoiceContainerProps) {
  return <div className={`flex flex-col h-full ${className}`}>{children}</div>;
}

/**
 * Slot for voice content (idle screen, active screen, etc.)
 */
export function VoiceContentSlot({ children }: SlotProps) {
  return (
    <div className="flex-1 flex items-center justify-center overflow-hidden">
      {children}
    </div>
  );
}

/**
 * Slot for voice controls (mute, end call, etc.)
 */
export function VoiceControlsSlot({ children }: SlotProps) {
  return <div className="p-4 border-t border-border/40">{children}</div>;
}
